import React from "react";

const SideMenuWrap = (props) => {
  return (
    <div className="side-menu-wrap">
      <div className="side-menu">{props.children}</div>
    </div>
  );
};

export default SideMenuWrap;
